// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"100":"03268f753baa86d0","254":"4d0cf201df27fd92","397":"2281eaa60d56eb50"}[chunkId] + ".js";
};